<template>
  <div class="login-container">
    <!-- 导航栏 -->
    <van-nav-bar title="登录" />
    <!-- /导航栏 -->

    <!-- 登录表单 -->
    <van-form ref="loginForm" @submit="onSubmit">
      <van-field
        v-model="user.username"
        name="用户名"
        placeholder="请输入用户名"
        :rules="userFormRules.username"
        maxlength="11"
      >
        <i slot="left-icon" class="icon icon-shouji"></i>
      </van-field>
      <van-field
        v-model="user.password"
        type="password"
        name="密码"
        placeholder="请输入密码"
        :rules="userFormRules.password"
      >
        <i slot="left-icon" class="icon icon-yanzhengma"></i>
      </van-field>
      <div class="login-btn-wrap">
        <van-button class="login-btn" block type="info" native-type="submit">
          登录
        </van-button>
      </div>
    </van-form>
    <!-- /登录表单 -->
  </div>
</template>

<script >
import wx from "weixin-js-sdk";
import { login } from '@/api/login'
import { setToken, removeToken } from '@/utils/auth'
import { getAppId, getQyWxConfig } from '@/api/wx/wx'
import { getDict } from "@/utils/dict";

export default {
  name: 'LoginIndex',
  components: {},
  props: {},
  data() {
    return {
      user: {
        username: "admin", // 手机号
        password: "admin123" // 密码
        // code: "admin" // 验证码
      },
      userFormRules: {
        username: [
          {
            required: true,
            message: "用户名不能为空"
          },
        ],
        password: [{
          required: true,
          message: "密码不能为空"
        }]
      },
    }
  },

  computed: {},
  watch: {},
  created() {
    //this.onSubmit()
  },
  mounted() { },
  methods: { 

    async onSubmit() {
      // 1. 展示登陆中 loading
      this.$toast.loading({
        message: "登录中...",
        forbidClick: true, // 禁用背景点击
        duration: 0 // 持续时间，默认 2000，0 表示持续展示不关闭

      }); 
      removeToken()

      // 2. 请求登录
      const data = await login(this.user);
      console.log(data)
      if (data.code === 200) {// 登录成功
        setToken(data.token) // 把token 存到cookie
        this.$toast.success("登录成功");
        this.$router.push('/')
        this.weixinLogin()
        // this.$router.back();
      } else {
        this.$toast.fail("登录失败，请稍后重试");
      }
    },
    // 微信登录
    async weixinLogin() {
      // 1. 获取appId
      const data = await getAppId(1);
      console.log(data)
      const appId = data.data
      console.log(appId)
      // {"msg":"操作成功","code":200,"data":{"agentId":"1000029","url":null,"code":null,"corpId":"wx28c336ae49ff2243","corpSecret":"DdBuxT2mFZtT3oK3a-hhUKAoonFvnWdcG_RMPFXE_Q8"}}

      // 2.输入参数
      // {
      //   "agentId": "string",
      //   "code": "string",
      //   "corpId": "string",
      //   "corpSecret": "string",
      //   "url": "string"
      // }

      const dataConfig = await getQyWxConfig(appId)
      const wxConfig = dataConfig.data
      //{"msg":"操作成功","code":200,"data":{"signature":"3e80cd84b726d850934c016700382f1787a418d4","appId":"wx28c336ae49ff2243","nonceStr":"aab7470e-f966-4186-b2d3-06ff85012aef","timestamp":"1618328291"}}
      console.log(dataConfig);

      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId.corpId, // 必填，企业微信的corpID
        timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
        signature: wxConfig.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['selectExternalContact', 'getLocation', 'openLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      console.log('开始调用微信ready')
      wx.ready(function () {
        console.info('调用微信ready')
        openWeixin(appId)
      });

      wx.error(function (res) {
        console.log('微信调用失败', res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
      console.log('结束调用微信ready')

      function openWeixin(result) {
        console.info(result)
        if (result.corpId != "-1") {
          window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + result.corpId + '&redirect_uri=https://crm.suzan001.com' + ' & response_type=code & scope=snsapi_privateinfo & agentid=' + result.agentId + ' & state=1#wechat_redirect';
        } else {
          console.error("企业微信Corpid获取失败")
        }
      }
    }

  }
}
</script>
<style scoped lang="less">
/deep/.van-nav-bar__content {
  background-color: #6db4fb;
  .van-nav-bar__title {
    color: #fff;
  }
}
.login-container {
  .icon {
    font-size: 37px;
  }
  .send-sms-btn {
    width: 156px;
    height: 46px;
    line-height: 46px;
    background-color: #ededed;
    font-size: 20px;
    color: #666;
  }
  .login-btn-wrap {
    padding: 53px 33px;
    .login-btn {
      background-color: #6db4fb;
      border: none;
    }
  }
}
</style>